//import images from 'assets/images/images'
import React from 'react'

const Allergens = ({getItem}) => {
    // const allergensItem = [
    //     {
    //         name : "Gluten içeren tahıllar (buğday)",
    //         icon: images.gluten
    //     },
    //     {
    //         name : "Yumurta ve Yumurta ürünleri",
    //         icon: images.egg
    //     },
    //     {
    //         name : "Soya fasulyesi ve soya fasulyesi ürünleri",
    //         icon: images.soybean
    //     },
    //     {
    //         name : "Süt ve Süt ürünleri (Laktoz dahil)",
    //         icon: images.milk
    //     },
    //     {
    //         name : "Hardal ve hardal ürünleri",
    //         icon: images.mustard
    //     },
    //     {
    //         name : "Susam tohumu ve susam tohumu ürünleri",
    //         icon: images.sesame
    //     },
    //     {
    //         name : "Kükürtdioksit veya sülfitler",
    //         icon: images.sulfide
    //     },
    // ]

  return (
    <div className='allergens'>
       {
        getItem?.allergens.map((allergen,i) => (
            <div className='allergens-item' key={i}>
                <img src={allergen?.imageLink} alt="" />
                <div className='body-s'>{allergen.name}</div>
            </div>
        ))
       }
    </div>
  )
}

export default Allergens